import {Injectable} from '@angular/core';
import {Modal} from 'src/app/infrastructure/service/modal.service';
import {PremiumModalPage} from 'src/app/ui/webapp/page/customer-area/premium/premium-modal.page';

@Injectable({
  providedIn: 'root',
})
export class PremiumModalService {

  constructor(private modal: Modal) {}

  async present(): Promise<void> {
    await this.modal.present({
        component: PremiumModalPage,
        cssClass: 'p-5 rounded bg-black-100'
      }
    );
  }
}
